// export.ts — CSV export of the stash (all local; nothing leaves the device).

import type { Skein } from "./store";
import { usableYardage, weightLabel } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full stash CSV: Brand, Colorway, Fiber, Weight, Yardage/skein, Grams/skein, Skeins, Grams left, Usable yds, Dye lot, Bought where, Bought on, Price, Currency, Notes. */
export function skeinsCsv(skeins: Skein[]): string {
  return csv(
    ["Brand", "Colorway", "Fiber", "Weight", "Yardage/skein", "Grams/skein", "Skeins", "Grams left", "Usable yds", "Dye lot", "Bought where", "Bought on", "Price", "Currency", "Notes"],
    skeins.map((s) => [
      s.brand, s.colorway, s.fiber, weightLabel(s.weight),
      s.yardage_per_skein, s.grams_per_skein, s.skein_count, s.grams_remaining,
      Math.round(usableYardage(s)), s.dye_lot, s.bought_where, s.bought_on,
      s.price || "", s.currency, s.notes,
    ]),
  );
}

export function buildExport(skeins: Skein[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: skeinsCsv(skeins), filename: `skein-stash-${stamp}.csv` };
}
